import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/civilLeftImg.png";
import rightimg from "../../../assets/civilRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import civilBenefitsImg1 from "../../../assets/civilBenefitsImg1.png";
import civilBenefitsImg2 from "../../../assets/civilBenefitsImg2.png";
import civilBenefitsImg3 from "../../../assets/civilBenefitsImg3.png";
import civilBenefitsImg4 from "../../../assets/civilBenefitsImg4.png";
import civilBenefitsImg5 from "../../../assets/civilBenefitsImg5.png";
import civilBenefitsImg6 from "../../../assets/civilBenefitsImg6.png";
import civilBenefitsImg7 from "../../../assets/civilBenefitsImg7.png";
import civilBenefitsImg8 from "../../../assets/civilBenefitsImg8.png";
import civilBenefitsImg9 from "../../../assets/civilBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import civilFunActivityImg1 from "../../../assets/CivilFunActivitiesImg1.png";
import civilFunActivityImg2 from "../../../assets/CivilFunActivitiesImg2.png";
import civilFunActivityImg3 from "../../../assets/CivilFunActivitiesImg3.png";
import civilFunActivityImg4 from "../../../assets/CivilFunActivitiesImg4.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const CivilEngineeringPortal = () => {
  const CivilEngineeringPage = heroContent.CivilEngineeringPage;

  const foundationModules = [
    {
      title: "Module 1",
      activities: "03",
      classes: "02",
      description:
        "Structures - Understand structural forces by building a bridge with ice cream sticks.",
    },
    {
      title: "Module 2",
      activities: "03",
      classes: "02",
      description:
        "AutoCAD - Learn basic house planning using AutoCAD software.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Explore tools and machines used in construction projects.",
    },
    {
      title: "Module 4",
      activities: "03",
      classes: "02",
      description:
        "Construction Management - Learn how to manage construction processes and phases.",
    },
    {
      title: "Module 5",
      activities: "04",
      classes: "03",
      description:
        "Road Planning & Traffic Symbols - Understand traffic symbols and the role of civil engineers in road planning.",
    },
  ];

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "04",
      classes: "03",
      description:
        "Structures - Learn about structural forces using ETABS software to visualize stress points.",
    },
    {
      title: "Module 2",
      activities: "04",
      classes: "03",
      description: "AutoCAD - Create medium-level house plans using AutoCAD.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Explore machinery used in small and large construction projects.",
    },
    {
      title: "Module 4",
      activities: "04",
      classes: "03",
      description:
        "Construction Management - Learn construction processes and use Primavera P6 to schedule a house project.",
    },
    {
      title: "Module 5",
      activities: "03",
      classes: "02",
      description:
        "Road Planning & Traffic Symbols - Understand traffic signs and develop a road plan through a real-life scenario project.",
    },
  ];

  const advancedModules = [
    {
      title: "Module 1",
      activities: "04",
      classes: "03",
      description:
        "Structures - Explore structural forces using ETABS and understand their effects on buildings.",
    },
    {
      title: "Module 2",
      activities: "04",
      classes: "03",
      description:
        "AutoCAD - Design advanced house plans and get introduced to 3D modeling in AutoCAD.",
    },
    {
      title: "Module 3",
      activities: "04",
      classes: "03",
      description:
        "Construction Equipment - Learn about construction machinery and different types of construction projects.",
    },
    {
      title: "Module 4",
      activities: "04",
      classes: "03",
      description:
        "Construction Management - Understand construction processes and use Primavera P6 to plan a large-scale project.",
    },
    {
      title: "Module 5",
      activities: "03",
      classes: "02",
      description:
        "Road Planning & Traffic Symbols - Study traffic signs and create a road plan based on real-life scenarios.",
    },
    {
      title: "Module 6",
      activities: "03",
      classes: "02",
      description:
        "Soil Mechanics - Discover soil types, classification, and improvement techniques with a practical project.",
    },
  ];

  const benefitsData = [
    {
      title: "Civil Engineering Basics",
      description: "Learn core concepts and structures.",
      icon: civilBenefitsImg1,
    },
    {
      title: "Logic Skills",
      description: "Use coding blocks to solve problems.",
      icon: civilBenefitsImg2,
    },
    {
      title: "Creative Thinking",
      description: "Design smart and fun solutions.",
      icon: civilBenefitsImg3,
    },
    {
      title: "Problem Solving",
      description: "Tackle challenges step-by-step.",
      icon: civilBenefitsImg4,
    },
    {
      title: "Math & Analysis",
      description: "Improve numeric and data skills.",
      icon: civilBenefitsImg5,
    },
    {
      title: "Computational Skills",
      description: "Think like a coder and engineer.",
      icon: civilBenefitsImg6,
    },
    {
      title: "Career Exposure",
      description: "Explore tools used by engineers.",
      icon: civilBenefitsImg7,
    },
    {
      title: "Confidence & Speaking",
      description:
        "Enhances focus, attention span, and brain agility.Share ideas and present projects.",
      icon: civilBenefitsImg8,
    },
    {
      title: "STEAM Fun",
      description: "Hands-on learning with real tools.",
      icon: civilBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "IceCream Sticks Bridge",
      image: civilFunActivityImg1,
    },
    {
      title: "Primavera Project Plan",
      image: civilFunActivityImg2,
    },
    {
      title: "AutoCad Floor Plan",
      image: civilFunActivityImg3,
    },
    {
      title: "Construction & equipment Machinery",
      image: civilFunActivityImg4,
    },
  ];

  const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how our Brain Train Abacus Course can enhance your child's cognitive skills, memory, and concentration! Our video walks you through the exciting features of the course, the benefits of learning abacus, and how it can unlock your child's full potential.\n\nClick play and learn how we make learning fun, engaging, and effective for young minds.",
    videoSrc: "", // Replace with the actual video URL
  };

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={CivilEngineeringPage.titlePart1}
        titlePart2={CivilEngineeringPage.titlePart2}
        description={CivilEngineeringPage.description}
        buttonText={CivilEngineeringPage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        title="Beginner Level Course"
        modules={foundationModules}
      />
      <CourseTimeline
        title="Intermediate Level Course"
        modules={beginnerModules}
      />
      <CourseTimeline title="Advance Level Course" modules={advancedModules} />
      <Benefits
        title="How Students Can Benefit From Civil Engineering Course"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn Civil Engineering"
        subTitle="With 40+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default CivilEngineeringPortal;
